class SingleProductPurchase extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('[data-sp-variant-select]');
    this.form = this.querySelector('[data-sp-product-form]');
    this.image = this.querySelector('[data-sp-main-image]');
    if (this.select) this.select.addEventListener('change', () => this.updateVariant());
  }

  updateVariant() {
    const option = this.select.options[this.select.selectedIndex];
    const available = option.dataset.available === 'true';
    const input = this.form.querySelector('input[name="id"]');
    const button = this.form.querySelector('[data-sp-add]');
    const label = this.form.querySelector('[data-sp-add-label]');
    const price = this.form.querySelector('[data-sp-price]');
    const comparePrice = this.form.querySelector('[data-sp-compare-price]');
    const stock = this.form.querySelector('[data-sp-stock]');

    input.value = option.value;
    input.disabled = !available;
    button.disabled = !available;
    price.textContent = option.dataset.price;
    comparePrice.textContent = option.dataset.comparePrice || '';
    comparePrice.classList.toggle('is-hidden', !option.dataset.comparePrice);
    label.textContent = available ? this.dataset.addLabel : this.dataset.soldOutLabel;
    stock.textContent = available ? this.dataset.stockLabel : this.dataset.soldOutLabel;

    if (option.dataset.image && this.image) {
      this.image.src = option.dataset.image;
      this.image.removeAttribute('srcset');
    }
  }
}

if (!customElements.get('single-product-purchase')) {
  customElements.define('single-product-purchase', SingleProductPurchase);
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-sp-scroll-to-buy]');
  if (!trigger) return;
  const target = document.querySelector('[data-sp-buy-box]');
  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'center' });
});
